// Colours taken from the photos of Hindisvík: basalt, sea, sand and the red roof of the farmhouse
export const colors = {
  ink: '#2a2f33',
  muted: '#5b6770',
  sea: '#2f5d73',
  seaDark: '#22343d',
  seaLight: '#dde6ea',
  sand: '#f6f3ec',
  roof: '#a8382c',
};

export const headingFont = "'Lora', Georgia, 'Times New Roman', serif";

// Height of the sticky header, also used to offset in-page links so headings aren't hidden under it
export const headerHeight = '72px';
